
import React from 'react';
import { useTranslation } from 'react-i18next';
import GatsbyImageWrapper from '../GatsbyImageWrapper';
import { LocalizedLink } from '../primitives';

export function BlogSingle(blogArticle: any) {
    const { t } = useTranslation('templatePages');
    const { content_short, code, fields, title } = blogArticle;

    return (
        <div className='blogArticle'>
            <h3 className='title'>{title}</h3>
            <div className='blogArticleContent'>
                <GatsbyImageWrapper
                    fields={fields}
                    propertyToGet='thumbnail'
                    altComponent={<></>}
                />
                <p>{content_short}</p>
            </div>
            <LocalizedLink className='readMore' to={`/articles/${code}/`}>
                <>{t('read-more')}</>
            </LocalizedLink>
        </div>
    );
}
